import Permission from '@/shared/constants/Permission';

export type PermissionChecker = (actualPermissions: Array<Permission>) => boolean;

export function allPermissions(...requiredPermissions: Array<Permission>): PermissionChecker {
  return actualPermissions => requiredPermissions.every(p => actualPermissions.includes(p));
}

export function anyPermission(...requiredPermissions: Array<Permission>): PermissionChecker {
  return actualPermissions => requiredPermissions.some(p => actualPermissions.includes(p));
}
